import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=7ef2474a&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ef2474a"]])

export default __exports__